import React, { useState } from "react";
import { Loading } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import classNames from "classnames";
import BoxScore from "../../game-stats/components/BoxScore";
import commonStyles from "../../common/styles/Common.styles";
import boxScoreStyles from "../../game-stats/styles/BoxScore.styles";
import MissingStatsContainer from "../../game-stats/containers/MissingStatsContainer";
import PrintButton from "../../common/components/print/PrintButton";

const BoxScoreContainer = ({ boxScore = {} }) => {
	const commonClasses = commonStyles();
	const classes = boxScoreStyles();

	const { awayTeamStats, homeTeamStats } = boxScore;

	const [isLoading, setIsLoading] = useState(false);

	return !awayTeamStats && !homeTeamStats ? (
		<MissingStatsContainer />
	) : (
		<Box className={commonClasses.container}>
			{isLoading && (
				<div style={{ position: "relative" }}>
					<div style={{ position: "absolute", width: "100%" }}>
						<Loading isFetching />
					</div>
				</div>
			)}

			<Box
				display="flex"
				justifyContent="flex-end"
				className={commonClasses.headerContainer}
			>
				<PrintButton isLoading={isLoading} setIsLoading={setIsLoading} />
			</Box>

			<Box className={classNames(commonClasses.contentContainer, classes.content)}>
				<Box padding={4}>
					<BoxScore boxScore={boxScore} />
				</Box>
			</Box>
		</Box>
	);
};

export default BoxScoreContainer;
